import BaseService from './BaseService.js'

export default {
  get(id) {
    return BaseService.get(`Change/${id}`)
  },
  getBySubmission(id) {
    return BaseService.get(`Change/Submission/${id}`)
  },
  post(change) {
    return BaseService.post(`Change`, change)
  },
  put(change) {
    return BaseService.put(`Change`, change)
  },
  delete(id) {
    return BaseService.delete(`Change/${id}`)
  }
}
